<template>
<div class="chapter">
<div class="inner_page">
<h1>The Doings</h1>
<h1 class="sigil_not_in_toc">Of Raffles Haw</h1>
<h2 class="sigil_not_in_toc">Arthur Conan Doyle</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?6d3eb3af